import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2/dist/sweetalert2.js';
import { BaseComponent } from '../base/base.component';
import { Account } from '../data/account';
import { Organization } from '../data/organization';

@Component({
  selector: 'app-account-detail',
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.css']
})
export class AccountDetailComponent extends BaseComponent implements OnInit {
  account: Account;
  accountId: number;
  isMyAccount = false;
  organizations: Organization[];
  rolesMap = {};

  ngOnInit() {
    // check for super
    this.accountId = +this.route.snapshot.paramMap.get('id');
    if (!this.accountId || this.accountId === this.authService.session.ID) {
      this.isMyAccount = true;
      this.accountId = this.authService.session.ID;
    }
    this.getAccount();
    this.dataService.getAdministratorRoles().subscribe(roles => roles.forEach(role => this.rolesMap[role.Code] = role.Description));
  }

  deleteAccount() {
    this.dataService.promptDelete(`This will permanently delete the account ${this.account.Name}.`)
      .then(() => {
        this.deleteObj = this.account;
        this.dataService.deleteAccount(this.accountId).subscribe(result => {
          this.router.navigate(['/accounts']);
        });
      });
  }

  getAccount(): void {
    this.dataService.getAccount(this.accountId).subscribe(account => {
      this.account = account;
      this.getOrganizations();
    });
  }

  getOrganizations(): void {
    this.dataService.getAccountOrganizations(this.account.ID)
      .subscribe(organizations => this.organizations = organizations);
  }

  isValid(): boolean {
    if (!this.account.Name) {
      swal.fire('Oops!', 'Name is required.', 'error');
      return false;
    }
    if (!this.account.Email) {
      swal.fire('Oops!', 'Email is required.', 'error');
      return false;
    }
    return true;
  }

  sendWelcomeEmail(accountId: number) {
    this.sendingWelcomeEmail = true;
    this.dataService.sendAccountWelcomeEmail(accountId).subscribe(response => {
      this.sendingWelcomeEmail = false;
      if (response.Success) {
        swal.fire('Success!', 'Welcome email has been resent.', 'success');
      }
    });
  }

  updateAccount() {
    if (!this.isValid()) {
      return;
    }
    this.startSaveObj(event);
    this.dataService.updateAccount(this.account).subscribe(tmpAccount => {
      if (tmpAccount) {
        if (this.isMyAccount) {
          this.authService.session.Name = this.account.Name;
        }
        this.account.Password = '';
        this.handleSaveSuccess();
      } else {
        this.handleSaveError();
      }
    });
  }
}
